import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "style__Container",
  componentId: "sc-1x6mk14-0"
})(["width:100%;height:100%;display:flex;align-items:center;background:#dcecee;position:fixed;top:0;bottom:0;left:0;right:0;z-index:999;overflow:hidden;"]);
export var PanelContainer = styled.div.withConfig({
  displayName: "style__PanelContainer",
  componentId: "sc-1x6mk14-1"
})(["width:100%;display:flex;justify-content:center;align-items:center;flex-wrap:wrap;margin:0 auto 3em;height:500px;"]);
export var Panel = styled.div.withConfig({
  displayName: "style__Panel",
  componentId: "sc-1x6mk14-2"
})(["height:350px;width:466px;padding:32px;margin:16px;background:white;border-radius:10px;"]);
export var Title = styled.div.withConfig({
  displayName: "style__Title",
  componentId: "sc-1x6mk14-3"
})(["font-size:2em;width:100%;margin:0 0 0.25em;padding:0 0 0.5em;border-bottom:2px solid ", ";text-align:center;"], function (props) {
  return props.color ? props.color : 'white';
});
export var Sentence = styled.div.withConfig({
  displayName: "style__Sentence",
  componentId: "sc-1x6mk14-4"
})(["font-weight:bold;font-size:1em;width:100%;margin:0 0 0.25em;padding:0 0 0.5em;text-align:center;"]);
export var Button = styled.div.withConfig({
  displayName: "style__Button",
  componentId: "sc-1x6mk14-5"
})(["font-weight:bold;font-size:1.3em;margin-top:auto;border-radius:5px;background:rgb(48,194,255);height:40px;line-height:40px;transition:background 0.3s;text-align:center;color:white;&:hover{background:rgb(0,140,198);}"]);
export var Space = styled.div.withConfig({
  displayName: "style__Space",
  componentId: "sc-1x6mk14-6"
})(["width:100%;height:", ";"], function (props) {
  return props.h ? props.h : '60px';
});
export var SpinnerBox = styled.div.withConfig({
  displayName: "style__SpinnerBox",
  componentId: "sc-1x6mk14-7"
})(["color:red;width:57px;position:relative;margin:auto;float:left;top:30%;left:50%;transform:translate(-50%,-50%);"]);